// extracted by mini-css-extract-plugin
module.exports = {"garment":"style-module--garment--2mD7O","garmentImage":"style-module--garmentImage--2UPCg","garmentPrice":"style-module--garmentPrice--OTVOh","modal":"style-module--modal--2eup1"};